<template>
   <div class="cssload-whirlpool">
      <b class="c0"></b>
      <b class="c1"></b>
      <b class="c2"></b>
   </div>
</template>

<script>
    export default {
        name: "InlinedLoader"
    }
</script>

<style scoped lang="scss">
   @import "../theme/theme";

   @function loader-u($_v) {
      @return ($_v/50);
   }

   .cssload-whirlpool {
      display: grid;
      width: loader-u(49em);
      height: loader-u(49em);
      justify-items: center;
      align-items: center;
      b {
         border: 1px solid $text20;
         border-left-color: $accent100;
         border-radius: 100rem;
         grid-row: 1;
         grid-column: 1;
      }
      .c0 {
         height: loader-u(30em);
         width: loader-u(30em);
         animation: cssload-rotate 1150ms linear infinite;
      }

      .c1 {
         height: loader-u(40em);
         width: loader-u(40em);
         animation: cssload-rotate 1550ms linear infinite;
      }
      .c2 {
         height: loader-u(50em);
         width: loader-u(50em);
         animation: cssload-rotate 2300ms linear infinite;
      }
   }


   @keyframes cssload-rotate {
      100% {
         transform: rotate(360deg);
      }
   }
</style>